import httpClient from "./httpClient";

const base = "/payslips";

export function generatePayslip(payload) {
  return httpClient.post(base, payload).then((res) => res.data.data);
}
export function batchGeneratePayslips(payload) {
  return httpClient.post(`${base}/batch`, payload).then((res) => res.data);
}
export function listPayslipsForStudent(identificationId) {
  return httpClient.get(base, { params: { identificationId } }).then((res) => res.data.data);
}
export function listPendingPayslips() {
  return httpClient.get(`${base}/pending`).then((res) => res.data.data);
}
export function listPayslipsBySection(classConfigId, academicYear, payslipStatus) {
  return httpClient.get(`${base}/section`, { params: { classConfigId, academicYear, payslipStatus } }).then((res) => res.data.data);
}
export function getPayslip(payslipId) {
  return httpClient.get(`${base}/${payslipId}`).then((res) => res.data.data);
}
export function deletePayslip(payslipId) {
  return httpClient.delete(`${base}/${payslipId}`).then((res) => res.data);
}
export function collectPayslips(payload) {
  return httpClient.post(`${base}/collect`, payload).then((res) => res.data);
}
